import { ColDef } from 'ag-grid-community';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { JSON_PRE_GERADO_TIPO } from '@gestor-web/@core/api/ords/model';
import { Store } from '@ngrx/store';
import { CompetenciaPipe } from '@gestor-web/app/shared/pipes/competencia.pipe';
import { NotificationService } from '@gestor-web/app/shared/services';
import { AnalisesService } from '../../analises.service';
import { BaseConsultaComponent } from './base-consulta.component';
import { GridService } from '@gestor-web/app/shared/services/grid.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GeralService } from '@gestor-web/app/shared/services/geral.service';

const COLUMNS: ColDef[] = [
  // Pivot (area=column)
  /*
  {
    headerName: 'Operadora',
    field: 'DS_OPERADORA',
    pivotIndex: 0,
  },
  {
    headerName: 'Ano-base',
    field: 'NR_ANO_BASE',
    width: 75,
    pivotIndex: 1,
  },
  */
  {
    headerName: 'Classe',
    field: 'SG_CLASSE',
    pivotIndex: 2,
  },
  {
    headerName: 'Status CNS',
    field: 'DS_CNS',
    pivotIndex: 3,
  },

  // Row Groups (area=row)
  {
    headerName: 'Tabela TUSS',
    field: 'CD_TABELA_TUSS',
    rowGroupIndex: 0,
    sort: 'asc',
  },
  {
    headerName: 'Vínculo internação',
    field: 'DS_VINCULO_INTERNACAO',
    rowGroupIndex: 1,
    sort: 'asc',
  },
  {
    headerName: 'Nome proced. item',
    field: 'NM_PROCED_ITEM',
    rowGroupIndex: 2,
    sort: 'asc',
  },
  {
    headerName: '021-Tipo de guia',
    field: 'DS_TIPO_GUIA',
    rowGroupIndex: 3,
    sort: 'asc',
  },

  // Aggs (area=data)
  {
    headerName: 'Qtde de guia',
    field: 'QT_GUIA',
    type: 'int',
    aggFunc: 'sum',
  },

  // Hidden (area=filter)
  {
    headerName: '045-Tipo de atendimento',
    field: 'DS_TIPO_ATENDIMENTO',
    hide: true,
  },
  {
    headerName: '003-Competência',
    field: 'NR_COMPETENCIA',
    type: 'competencia',
    hide: true,
  },
  {
    headerName: '029-Data realização ou inicio atendimento',
    field: 'NR_ANO_MES_REALIZACAO',
    hide: true,
  },
  {
    headerName: '035-Cód. CBO executante',
    field: 'DS_CBO_EXEC',
    hide: true,
  },
  {
    headerName: '034-Tipo de consulta',
    field: 'DS_TIPO_CONSULTA',
    hide: true,
  },
  {
    headerName: '066-Cód. procedimento ou item',
    field: 'CD_PROCED_ITEM',
    hide: true,
  },
];

@Component({
    selector: 'bl-indicadores-consulta-resumo-consultas-eletivas',
    templateUrl: './base-consulta.component.html',
    styleUrls: ['./base-consulta.component.scss'],
    providers: [DecimalPipe],
    standalone: false
})
export class ResumoConsultasEletivasComponent extends BaseConsultaComponent {
  constructor(
    service: AnalisesService,
    notificationService: NotificationService,
    gridService: GridService,
    geralService: GeralService,
    competeciaPipe: CompetenciaPipe,
    decimalPipe: DecimalPipe,
    datePipe: DatePipe,
    store: Store,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      service,
      notificationService,
      gridService,
      geralService,
      competeciaPipe,
      decimalPipe,
      datePipe,
      store,
      router,
      route,
    );
  }

  getColumns(): ColDef[] {
    return COLUMNS;
  }

  getPageTooltip(): string {
    return 'CUBOS_ANALISE.METRICAS.RESUMO_CONSULTA_ELETIVA';
  }

  getConsultaTipo(): JSON_PRE_GERADO_TIPO {
    return 'IND_CUBO_RESUMO_GUIA_CONSULTA';
  }

  getExportTitle(): string {
    return 'Cubos de análise - Resumo das consultas eletivas';
  }

  getExportFilePrefix(): string {
    return 'Cubos-Resumo-Consultas-Eletivas';
  }
}
